import PropTypes from 'prop-types';

const templateServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  duplicateActivity: PropTypes.func,
});

export default templateServiceShape;
